import { useEffect } from "react";
import AddUser from "./Components/AddUser.component";
import UpdateRolePermissions from "./Components/UpdateRolePermissions";
import UpdateUserRole from "./Components/UpdateUserRole";
import UserDetail from "./Components/UserDetail.component";
import { MixPanel } from "../../../../shared/MixPanel/MixPanel";

interface IUserModalDataRecord {
  type:
    | "update_user"
    | "view_user"
    | "add_user"
    | "update_user_role"
    | "update_role_permissions";
  rolesData?: any;
  user?: any;
  data?: any;
  action?: (...args: any[]) => any;
}

interface IUserModalProperties {
  dataRecord: IUserModalDataRecord;
}

interface IUserCreationModalProps {
  properties: IUserModalProperties;
  onCloseModal: () => void;
}

const UserCreationModal = ({
  properties: { dataRecord },
  onCloseModal,
}: IUserCreationModalProps) => {
  const { type, rolesData } = dataRecord;

  useEffect(() => {
    MixPanel.track(`Page View: UserCreation.tsx`, {
      page: "UserCreation.tsx",
    });
  }, []);

  return (
    <div
      className="Modal__dialog md-lg-modal animated slideInDown"
      role="document"
    >
      <div
        className="AuditTrailModal Modal__content"
        style={{ overflow: "hidden" }}
      >
        <div className="Modal__body">
          {(() => {
            switch (type) {
              case "update_user":
              case "view_user":
                return (
                  <UserDetail
                    dataRecord={dataRecord}
                    onCloseModal={onCloseModal}
                  />
                );
              case "add_user":
                return (
                  <AddUser
                    dataRecord={dataRecord}
                    onCloseModal={onCloseModal}
                    rolesData={rolesData}
                  />
                );
              case "update_user_role":
                return (
                  <UpdateUserRole
                    dataRecord={dataRecord}
                    onCloseModal={onCloseModal}
                  />
                );
              case "update_role_permissions":
                return (
                  <UpdateRolePermissions
                    dataRecord={dataRecord as any}
                    onCloseModal={onCloseModal}
                  />
                );
              default:
                return null;
            }
          })()}
        </div>
      </div>
    </div>
  );
};

export default UserCreationModal;
